<script lang="ts">
  import { getContext } from 'svelte';
  import { isAfterDay, isDate } from '../components/Util.svelte';
  import InvoiceDetailModal from '../etc/modal/InvoiceDetailModal.svelte';
  const { open }: any = getContext('simple-modal');
  import RepositoryFactory, { HATENOHAMA } from '../repositories/RepositoryFactory';
  import Loading from '../etc/loader.svelte';
  import { loginUser } from '../components/auth/LoginUser';
  const hatenohamaRepository = RepositoryFactory[HATENOHAMA];

  let billYm = '';
  let noticeMessage = '';
  $: isLoading = false;

  // 集約請求情報取得
  function showDetailPopup() {
    noticeMessage = '';
    if (!isDate(billYm + '01')) {
      noticeMessage = '請求年月を正しく入力してください。';
      return;
    }
    if (isAfterDay(billYm + '01')) {
      noticeMessage = '当月以前の年月を指定してください。';
      return;
    }

    isLoading = true;

    hatenohamaRepository
      .getDetailAggregation({ billYm })
      .then((res) => {
        if (!res?.length) {
          noticeMessage =
            '指定いただいた請求年月には表示対象の請求が存在しません。<br />請求年月を指定しなおしてください。';
          isLoading = false;
          return;
        }
        open(InvoiceDetailModal, {
          detailAggregations: res
        });
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          noticeMessage = 'エラーが発生しました。申し訳ございませんが時間が経ってから操作してください。';
        }
        throw new Error();
      });
    isLoading = false;
  }
</script>

<div class="mb-5 screen-title">
  <span class="text-gray-700 text-2xl font-bold">適格請求書/適格返還請求書</span>
</div>
{#if isLoading}
  <Loading />
{/if}
<div class="flex mb-4">
  <div class="shadow rounded bg-white border-t-4 border-green-400">
    <div class="flex flex-col">
      <div class="flex-1">
        <div class="text-sm p-4">
          <span
            >インボイス制度に対応した適格請求書/適格返還請求書<br />
            を確認することが可能です。<br />
            下記より、対象の請求年月を指定の上、「次へ」ボタンを押してください。</span
          >
        </div>
      </div>
      <div class="flex-1">
        <div class="flex flex-row justify-items-center items-center min-w-full p-4 screen-flex-column">
          <div class="justify-self-auto mx-2">
            <span class="label-title">請求年月</span>
          </div>
          <div class=" justify-self-auto mx-2">
            <input class="w-full" type="text" placeholder="YYYYMM" maxlength="6" bind:value={billYm} />
          </div>
          <div class="screen-button mx-2">
            <button on:click={showDetailPopup} class="button-primary"> 次へ </button>
          </div>
          {#if noticeMessage}
            <div class=" bg-red-100 border-red-500 text-red-700 px-4 py-2 text-sm screen-message" role="alert">
              <p class="font-bold">{@html noticeMessage}</p>
            </div>
          {/if}
        </div>
      </div>
      <div class="flex-1">
        <div class="shadow rounded-lg bg-gray-200 border-1 m-5 p-4">
          <div class="justify-self-start w-full inline-block">
            <ul>
              <li>インボイス制度における適格請求書/適格返還請求書の詳細は国税局サイト等にて確認してください</li>
              <li>
                請求年月とは、弊社がお客様への請求内容を確定した年月であり、お客様の決済方法により、実際にお支払いいただいた年月とは必ずしも一致しません
              </li>
              <li>適格請求書/適格返還請求書は、お支払いの完了が確認できているもののみ参照可能となっております</li>
              <li>
                本マイページ内にある請求金額確認画面から参照できる請求年月別の請求内容はインボイス制度に適応した内容となっておりません。インボイス制度に適応した適格請求書/適格返還請求書が必要な場合は上記より参照してください
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-5 py-2;
  }
  .label-title {
    @apply text-gray-900 font-semibold;
  }
  .screen-title {
    @apply text-left;
  }
  ul {
    @apply pl-4 list-disc text-sm;
  }
  input[type='text'] {
    @apply rounded border py-2 px-3 text-sm placeholder-gray-400 focus:placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-green-200 focus:border-transparent;
  }
  @media screen and (max-width: 640px) {
    .screen-title {
      @apply text-center;
    }
  }
  @media screen and (max-width: 640px) {
    .screen-flex-column {
      @apply flex flex-col;
    }
  }
  @media screen and (max-width: 640px) {
    .screen-button {
      @apply mt-2.5;
    }
  }
  @media screen and (max-width: 640px) {
    .screen-message {
      @apply mt-2.5;
    }
  }
</style>
